import { styled } from "@mui/material";
import { makeStyles } from '@mui/styles';
import { APP_BACKGROUND_COLOR, BORDER_COLOR } from "../../theme";

export const backdropStyles = makeStyles({
  parent: {
    position: "relative",
    zIndex: 0,
    color: "white",
  },
  backdrop: {
    position: "absolute",
    color: "white",
  },
});

export const SelectUserContainer = styled("div")(({ theme }) => ({
  display: "flex",
  padding: "1%",
  width: "100%",
  [theme.breakpoints.down("sm")]: {
    justifyContent: "center",
  },
  [theme.breakpoints.up("sm")]: {
    justifyContent: "flex-end",
  },
}));

export const styles = {
  backButton: {
    border: `1px solid ${BORDER_COLOR}`,
    textTransform: "none",
    marginBottom: '10px',
    marginRight: "10px"
  } as const,
  autoComplete: {
    width: "100%",
    margin: "auto",
    maxWidth: "300px",
  } as const,
  drawerMessageContainer: {
    position: "absolute",
    marginTop: -2,
    width: "290px",
  } as const,
  chatBoxContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end"
  } as const,
  maximizedBox: {
    position: "fixed",
    top: 0,
    left: 0,
    transition: "width 1s",
    width: "435px",
    height: "100%",
    backgroundColor: APP_BACKGROUND_COLOR,
    border: `2px solid ${BORDER_COLOR}`,
    zIndex: 1000,
    overflowY: "auto",
    scrollbarWidth: "none"
  } as const,
};
